import * as angular from 'angular';

import { ComponentDefinition, ContextualField, PropertyType, AggregationMode } from '../../../models';
import { FlowChartConfiguration } from '../flowChart.configuration';
import * as Fields from '../../../common/helpers/contextual';

class FlowChartContextualController implements angular.IComponentController {
    configuration: FlowChartConfiguration;
    formController: angular.IFormController;
    isLoading: boolean;
    loadingMessage: string;
    properties: ContextualField[];

    readonly save: () => void;
    readonly cancel: () => void;

    static $inject = ['$q'];

    constructor(private _$q: angular.IQService) {
    }

    $onInit() {
        if (this.configuration.aggregation.mode === undefined) {
            this.configuration.aggregation.mode = AggregationMode.Average;
        }
        this.initProperties();
    }

    private initProperties() {
        const backgroundField = angular.copy(Fields.Background);
        backgroundField.extraData.target = '#filePickerModal';
        backgroundField.label = 'Image';
        if (this.configuration.alignedOn === undefined) {
            this.configuration.alignedOn = 0;
        }
        const properties: ContextualField[] = [
            angular.copy(Fields.AggregationMode),
            angular.copy(Fields.AggregationPeriod),
            backgroundField,
            angular.copy(Fields.MinPeriod),
            angular.copy(Fields.MaxPeriod),
            angular.copy(Fields.PeriodReference),
            angular.copy(Fields.IsEndDateIncluded),
            angular.copy(Fields.ShowAlarms),
            {
                modelName: 'showGrid',
                propertyType: PropertyType.Boolean,
                label: 'Show grid',
                propertyName: 'showGridProperty',
                required: false,
                icon: 'fa-file-text-o'
            }
        ];
        this.properties = properties;
    }

    onSave(): angular.IPromise<void> {
        return this._$q.when(this.save());
    }

    onCancel() {
        this.cancel();
    }
}

export const wtFlowChartContextual: ComponentDefinition = {
    componentId: 'wtFlowChartContextual',
    controller: FlowChartContextualController,
    template: require('./flowChartContextual.component.html'),
    controllerAs: 'vm',
    bindings: {
        cancel: '&',
        configuration: '=',
        formController: '=',
        save: '&'
    }
};